import * as React from 'react';

import PrimaryButton from '../../../../../shared/buttons/PrimaryButton';

interface Props {
  onPress: () => void;
}

const NewEffectUsageHistoryButton: React.FunctionComponent<Props> = props => {
  const {onPress} = props;
  return <PrimaryButton onPress={onPress}>エフェクトを選ぶ</PrimaryButton>;
};

export default React.memo(NewEffectUsageHistoryButton);
